import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Trans, useI18next } from "gatsby-plugin-react-i18next"
import styled, { css } from "styled-components"
import { fmobile, fresponsive, ftablet } from "utils/fullyResponsive"
import Button from "components/buttons/Button"
import InnerWrapper from "components/InnerWrapper"
import VideoModal from "components/Banners/VideoModal"
import Callout from "components/TextElements/Callout"
import AnimatedPath from "components/UI-Related/AnimatedPaths"
import { ReactComponent as APIPathsSVG } from "images/cards/apiPaths.svg"
import colors from "styles/colors"
import media from "styles/media"
import text from "styles/text"
import useMedia from "utils/useMedia"
import { useState } from "react"
interface Props {
    demoWidgetURL:string
}
export default function CoastDemoWidget({demoWidgetURL}:Props) {
    const { t } = useI18next()

    const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <InnerWrapper
        setWidth={useMedia("1440px", "86.747vw", "81.445vw", "89.333vw")}
      >
        <Content>
        <video autoPlay loop muted playsInline>
          <source
            src="https://res.cloudinary.com/dqhc2ysny/video/upload/v1696534622/GalileoEmbed_wrjsbq.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
       
        <Overlay></Overlay>
        <OverlayContent>
        <Title>{t("Experience financial innovation firsthand.")}</Title>
        <Body>
          <Trans>
          Learn how our solutions can elevate your offerings with a personalized self-guided demo of our APIs.
          </Trans>
        </Body>
        <Button styledLink onClick={()=>{
         setIsOpen(!isOpen);
        }} arrow>
          <Trans>Launch Your Demo</Trans>
        </Button>
        </OverlayContent>
        </Content>
      </InnerWrapper>
      {isOpen &&<VideoModal
            // hideCloseButton
            setShow={() => {
               setIsOpen(!isOpen)
            }}
            open
          >
            <VideoIframe
              id="chiliPiperIframe"
              allow="fullscreen;"
              title="Schedule a meeting"
              src={demoWidgetURL}
              width="100%"
              height="600px"
            />
          </VideoModal>}
    </Wrapper>
  )
}
export function CoastDemoOuterWrapper({demoWidgetURL}:Props){
    return <OuterWrapper>
        <CoastDemoWidget demoWidgetURL={demoWidgetURL}></CoastDemoWidget>
    </OuterWrapper>
}
const OuterWrapper = styled.div`
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    ${media.mobile} {
        width: 335px;
        height: 428px;
    }
`
const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${media.fullWidth} {
    padding: 150px 0;
  }
  ${media.desktop} {
    padding: 0 0 9.036vw 0;
  }
  ${media.tablet} {
    padding: 7.813vw 0;
  }
  ${media.mobile} {
    position: relative;
    width: 100%;
    height: 100%;
  }
`
const Content = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 9.036vw;
  align-items: center;
  ${media.fullWidth} {
    gap: 150px;
  }

  ${media.tablet} {
    flex-direction: column-reverse;
    gap: 7.813vw;
  }
  ${media.mobile} {
    flex-direction: column-reverse;
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 11.3122px;
  }
`
const Overlay = styled.div`
position: absolute;
border-radius: 11.3122px;
  top: 0;
//   left: 10%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    20deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(9, 9, 121, 0.7) 35%,
    rgba(0, 212, 255, 0.1) 100%
  );
  z-index: 1;
`
const OverlayContent = styled.div`
position: absolute;
bottom: 50px;
left: 20px;
text-align: left;
color: #fff;
z-index: 1;
${media.mobile} {
   width: 70vw;
   bottom: 20px
  }

`

const Title = styled.div`
  position: relative;
  ${text.h3};
  color: ${colors.white};
  display: flex;
  flex-wrap: wrap;

  ${fresponsive(css`
    margin-bottom: 20px;
    gap: 0 20px;
  `)}

  ${ftablet(css`
    ${text.h3};
    gap: 0 15px;
  `)}

  ${fmobile(css`
    gap: 0 10px;
    ${text.h6};
    margin-bottom: 10px;
    height: 123px;
  `)}
`
const Body = styled.p`
  ${text.bodyR};
  color: ${colors.blue10};

  ${fresponsive(css`
    margin-bottom: 40px;
    width: 627px;
  `)}

  ${ftablet(css`
    width: 485px;
  `)}

  ${fmobile(css`
    width: 70vw;
  `)}
`
const VideoIframe = styled.iframe<{ richText?: boolean }>`
  position: relative;
  aspect-ratio: 16/9;
 width: 100%;
  outline: none;
  border: none;
  overflow: hidden;

  ${media.fullWidth} {
    margin: 100px 0;
    border-radius: 20px;
  }
  ${media.desktop} {
    margin: 6.024vw 0;
    border-radius: 1.205vw;
  }
  ${media.tablet} {
    margin: 9.766vw 0;
    border-radius: 1.953vw;
  }
  ${media.mobile} {
    // width: 100%;
    margin: 13.333vw 0;
    border-radius: 2.667vw;
  }
`